import styled from 'vue-styled-components'

const StyledSocialsList = styled.ul`
  display: flex;
  list-style: none;
`

const StyledSocialsItem = styled.li`

  &:not(:last-child) {
    margin-right: 2px;
  }
`

const StyledSocialsLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  
  svg {
    width: 23px;
    height: auto;
  }
  
  &:hover {
    background-color: ${props => props.theme.colors.primary};
    
    svg path {
      fill: #fff;
    }
  }
`

export {
  StyledSocialsList,
  StyledSocialsItem,
  StyledSocialsLink
}



// WEBPACK FOOTER //
// ./src/components/Socials/StyledSocials.js